import React, { useEffect, useMemo, useState } from 'react'
import { ManufacturersContext } from '.'
import { ManufacturerModel } from '../models'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { fetchManufacturer } from '../api'

interface Props {
  children?: React.ReactNode
}

/**
 * Manufacturers Provider
 */
const Provider: React.FC<Props> = ({ children }) => {
  const [manufacturers, setManufacturers] = useState<ManufacturerModel[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | AuthFetchError | undefined>(undefined)
  const [hasError, setHasError] = useState(false)
  const authFetch = useAuthFetchWithResponse()

  useEffect(() => {
    const getManufacturer = async (): Promise<void> => {
      setLoading(true)
      const { error, hasErrors, value } = await fetchManufacturer(authFetch)

      setHasError(hasErrors)
      if (error) setError(error)
      if (value) setManufacturers(value)
      setLoading(false)
    }

    getManufacturer()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const memoizedValue = useMemo(() => ({ hasError, loading, manufacturers, error }), [hasError, loading, manufacturers, error])

  return <ManufacturersContext.Provider value={memoizedValue}>{children}</ManufacturersContext.Provider>
}

export default Provider
